

    import { defineComponent, PropType } from 'vue';
    import { CardDetail } from '@/catalog-app/types';

    export default defineComponent({
        props: {
            name: String,
            url: String,
            type: {
                type: String,
                default: 'item',
            },
            img: {
                type: String,
                default: '/static/img/coming-soon.jpg',
            },
            details: {
                type: Array as PropType<CardDetail[]>,
                required: false,
                default: () => []
            },
            promo: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
        setup() {
            return { }
        },
        data() {
            return {
                value: []
            }
        },
    });
